// removed by extract-text-webpack-plugin
module.exports = {"carousel":"_2txNcbdE2k7VkPAxytqBZ4","Carousel_side":"_2fd7kcVDYQWk2naQQUhq0a","Carousel_side_right":"_2hC1yOdNXqdRWJC3puvyZ7","dotsClass":"_2eDNQmN6AEWrJIQOW9mvVd","slick-active":"_13XcskGSrVSI7ggK4rmJve"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyCarousel/GoeasyCarousel.scss
 ** module id = 259
 ** module chunks = 0
 **/